import {
  vwoAccountId,
  vwoKeys,
  CURRENT_VWO_EXPERIMENTS,
} from "../config/vwoKeys";
import Utility from "./utility";
import vwoSDK from "vwo-node-sdk";

const getSettingFile = async (experimentName) => {
  try {
    const vwoKey =
      window._siteProps_?.props?.build_env_var === "production"
        ? vwoKeys[experimentName].prod
        : vwoKeys[experimentName].stage;

    const vwoSettingFile = await vwoSDK.getSettingsFile(vwoAccountId, vwoKey);
    const vwoClientInstance = await vwoSDK.launch({
      isDevelopmentMode: false,
      settingsFile: vwoSettingFile,
    });

    return vwoClientInstance;
  } catch (e) {
    return {
      track: function () {
        return;
      },
      activate: function () {
        return;
      },
    };
  }
};

const updateIntoStoredVwoVariations = (experimentName, variationName) => {
  let __ = Utility.tryJsonParse(sessionStorage.VWO_VARIATIONS);
  __[experimentName] = variationName;
  sessionStorage.VWO_VARIATIONS = JSON.stringify(__);
  return;
};

const getVariation = async (experimentName) => {
  if (!experimentName) return { "": "" };

  try {
    let queryParams = Utility.getQueryFromUrl();
    if (queryParams[experimentName]) {
      updateIntoStoredVwoVariations(
        experimentName,
        queryParams[experimentName]
      );
    }

    let _ = Utility.tryJsonParse(sessionStorage.VWO_VARIATIONS);
    if (experimentName in _) return { [experimentName]: _[experimentName] };
    //else return { [experimentName]: "" };

    const vwoClientInstance = await getSettingFile(experimentName);
    const deafultVWOID = localStorage.AB_TEST_VWO_ID || "";
    const VWOMID =
      deafultVWOID ||
      window?.crypto?.getRandomValues(new Uint32Array(1))[0].toString();
    if (!deafultVWOID) {
      localStorage.AB_TEST_VWO_ID = VWOMID;
    }

    let variationName = null;

    const vwoClientInstanceActivateFunc = async () => {
      try {
        variationName = await Utility.asyncCallWithTimeout(
          vwoClientInstance.activate(experimentName, VWOMID),
          2000
        );
      } catch (err) {}
    };

    await vwoClientInstanceActivateFunc();

    updateIntoStoredVwoVariations(experimentName, variationName);

    return { [experimentName]: variationName };
  } catch (e) {
    return { [experimentName]: "" };
  }
};

const getVwoExperimentsPromiseArray = () => {
  let experimentPromiseArray = [];
  for (const experiment of CURRENT_VWO_EXPERIMENTS) {
    experimentPromiseArray.push(getVariation(experiment));
  }
  return experimentPromiseArray;
};

export { getSettingFile, getVariation, getVwoExperimentsPromiseArray };
